import { render, staticRenderFns } from "./menu-selected.vue?vue&type=template&id=0f01dd77&scoped=true&"
import script from "./menu-selected.vue?vue&type=script&lang=js&"
export * from "./menu-selected.vue?vue&type=script&lang=js&"
import style0 from "./menu-selected.vue?vue&type=style&index=0&id=0f01dd77&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f01dd77",
  null
  
)

export default component.exports